import React from 'react';
import Button from '@components/legacy/core/Button';
import { useApplicantEvaluation } from '../context';
import { yourEvaluationTab } from '../config';
import { useTranslations } from '../../context/TranslationContext';
import TabList from '../../core/TabList';
import Dropdown from '../../core/Dropdown';
import { DropdownProvider } from '../../context/DropdownContext';
import TabSwitch from '../../TabsSwitch';

const Header = ({ steps = [], step, sections = [], onChangeTab, onChangeStep }) => {
    const { t } = useTranslations();
    const { toggleCollapsed, isCollapsed, loading, activeTab, activeSection, setActiveSection, hasAnyQuestions } = useApplicantEvaluation();
    const currentTabs = activeSection?.tabs || [];

    const handleSectionChangeHandler = (key, toggleDropdown) => {
        setActiveSection(sections?.find(({ id }) => id == key));
        const _tabId = sections.find(({ id }) => id == key)?.tabs?.[0]?.id;
        if (_tabId != activeTab) {
            onChangeTab(_tabId);
        }
        toggleDropdown();
    }

    return (
        <div className='applicant-evaluation-header'>
            <div className='main-section'>
                {sections?.length > 0 && <DropdownProvider>
                    <Dropdown
                        label={activeSection?.text || ''}
                        className='evaluation-tab-dropdown'
                        icon={"icon-svg-chevron-down"}
                        iconPosition="right"
                        btnClass="btn btn-link btn-secondary"
                        id="all-evaluations-dropdown"
                    >
                        {({ toggleDropdown }) => (sections?.map(({ id, text }, index) => {
                            return <li key={index} onClick={() => handleSectionChangeHandler(id, toggleDropdown)}><a>{text}</a></li>
                        }))}
                    </Dropdown>
                </DropdownProvider>
                }
                <div className='actions'>
                    {activeTab == yourEvaluationTab && hasAnyQuestions && (
                        <Button
                            type='default'
                            altTitle={isCollapsed ? t('Show feedback fields') : t('Hide feedback fields')}
                            className='btn-collapsed'
                            disabled={loading}
                            icon={isCollapsed ? 'icon-svg-maximize-01' : 'icon-svg-minimize-01'}
                            onClick={toggleCollapsed}
                            isLink
                        />
                    )}
                    {activeTab != yourEvaluationTab && currentTabs.length > 0 && (
                        <TabSwitch tabs={currentTabs} activeTab={activeTab} onChangeTab={(tab) => onChangeTab(tab?.id)} />
                    )}
                </div>
            </div>
            <TabList id="applicant-evaluation-tabs" value={step?.id} variant="horizontal-pill">
                {steps?.map(({ id, name }) => {
                    return <TabList.Item key={id} id={id} active={id === step?.id} onClick={() => onChangeStep(id)}>
                        {name}
                    </TabList.Item>
                })}
            </TabList>
        </div>
    );
};

export default Header;
